export default "__VITE_ASSET__BSp_V_Q0__"